import TabNavigation from './TabNavigation';

export default TabNavigation;
